import { validateAssessmentDefinition } from '../lib/assessmentSchema.mjs';
import { assessmentConfig } from './site';

// Every assessment owns its own URL slug, copy, tracking IDs, questions and report template.
// Never place gateway API keys or OTP signing secrets in browser configuration.
export const assessments = {
  'timesheet-to-invoice': {
    id:'timesheet-to-invoice',
    shortCode:'tsi',
    title:'Timesheet-to-Invoice Health Check',
    intro:'Is your timesheet-to-invoice process costing you money?',
    description:'Answer 9 quick questions and get your personalised Health Report in about 2 minutes.',
    questions:assessmentConfig.questions,
    reportType:'timesheet',
    tracking:{
      metaPixelId:import.meta.env.VITE_TSI_META_PIXEL_ID || '',
      gaMeasurementId:import.meta.env.VITE_TSI_GA_ID || '',
      clarityId:import.meta.env.VITE_TSI_CLARITY_ID || ''
    }
  }
};
// Fail closed when a developer introduces an incomplete or conflicting definition.
const shortCodes=new Set();
for(const [slug,assessment] of Object.entries(assessments)) {
  const problems=validateAssessmentDefinition(assessment);
  if(slug!==assessment.id) problems.push('Registry key must match assessment ID');
  if(shortCodes.has(assessment.shortCode)) problems.push('Duplicate short code');
  shortCodes.add(assessment.shortCode);
  if(problems.length) throw new Error('Invalid assessment definition '+slug+': '+problems.join('; '));
}
export const getAssessment = slug => assessments[slug] || null;
export const publicAssessmentBase = (import.meta.env.VITE_ASSESSMENT_PUBLIC_URL || '').replace(/\/$/, '');
export const assessmentLinks = (slug,base=publicAssessmentBase || window.location.origin,registry=assessments)=>({
  full:`${base}/a/${slug}`,
  short:`${base}/s/${registry[slug].shortCode}`
});
export function resolveAssessment(pathname) {
 const path=pathname.replace(/\/+$/,'');
 if(path===''||path==='/') return null; // The root is the public Assessment Hub directory.
 const short=path.match(/^\/s\/([a-z0-9-]+)$/);
 if(short) return Object.values(assessments).find(a=>a.shortCode===short[1]) || null;
 const full=path.match(/^\/a\/([a-z0-9-]+)$/);
 return full?getAssessment(full[1]):null;
}

// Dynamically published assessments are read-only public definitions, retrieved
// from the Gateway. Never allow them to override the protected legacy report.
export function resolvePublishedAssessment(pathname,catalog){
  const path=pathname.replace(/\/+$/,'');
  const full=path.match(/^\/a\/([a-z0-9-]+)$/);
  const short=path.match(/^\/s\/([a-z0-9-]+)$/);
  if(!Array.isArray(catalog)||(!full&&!short))return null;
  return catalog.find(a=>a.enabled===true&&a.id!=='timesheet-to-invoice'&&
    (full?a.id===full[1]:a.shortCode===short[1]))||null;
}